import React, { useState, useEffect, useRef } from "react";
import { CloseModal } from "utils/utils";
import NumberFormat from "react-number-format";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import moment from "moment";
import { getBranch } from "utils/utils";
import { getDate, process, formatDayMonth } from "utils/currencyFormat";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import { getUrl } from "utils/utils";
import { getUserLogin } from "utils/utils";
import numeral from "numeral";
import { CustomerParseFloat } from "utils/currencyFormat";
// import { BtnChiTiet } from "./ChiTietTongTienDaThanhToan/BtnChiTiet";
import { LamTronNghin } from "utils/utils";

export const ThongTinThanhToan = ({
    isShowTinhThanh,
    dataBanHang,
    setDataBanHang,
    sCode,
    setDHQuaHanThanhToan,
    setListNhomSP,
    setPageActive,
    isShowMenu,
    disEditAll,
    listChietKhauNhom,
    setListChietKhauNhom,
    setDisEditAll,
    setDisEditKH,
    setDisEditDonGia,
    updateTienCKNhom,
    listChietKhauNhomKH,
    setListChietKhauNhomKH,
    lamTron,
    setLoadding
}) => {
    const dispatch = useDispatch();
    const danhmuc = useSelector((state) => state.danhmuc);
    const { objDataBank, objConfigAll } = danhmuc;
    const saveButtonRef = useRef(null);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.ctrlKey && event.key.toLowerCase() === "s") {
                event.preventDefault(); // Ngăn chặn hành vi mặc định (mở hộp thoại "Save As")
                // Hiển thị cảnh báo trước khi chuyển trang
                const userConfirmed = window.confirm(
                    "Bạn có chắc chắn muốn lưu đơn bán hàng?"
                );

                if (saveButtonRef.current && userConfirmed) {
                    saveButtonRef.current.click(); // Kích hoạt sự kiện click của nút
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    useEffect(() => {
        // T?o listener v?i CloseModalXoa
        const escListener = CloseModal(() => toggleModalCanhBaoClose());

        // Thêm listener khi component mount
        escListener.addListener();

        // G? listener khi component unmount
        return () => {
            escListener.removeListener();
        };
    }, [CloseModal]); // Ch? thêm l?i effect n?u handleClose thay d?i
    const totalChietKhauNhom = listChietKhauNhom.reduce(
        (a, v) => (a = a + v.TienChietKhau * v.SoLuong),
        0
    );

    const [doubleClick, setDoubleClick] = useState(false);
    const [doubleClickChoDuyet, setDoubleClickChoDuyet] = useState(false);

    const [listCanhbao, setListCanhBao] = useState(null);
    const [isModalVisibleCanhBao, setModalVisibleCanhBao] = useState(false);
    const toggleModalCanhBao = () => {
        setModalVisibleCanhBao(!isModalVisibleCanhBao);
    };
    const toggleModalCanhBaoClose = () => {
        setDoubleClick(false);
        setModalVisibleCanhBao(false);
    };
    const saveBanHang = () => {
        const value = { ...dataBanHang };
        if (value.BranchID === 0) {
            pushNotification("Chưa xác nhận được chi nhanh đặt hàng. Vui lòng chọn lại chi nhánh", "error", "TOP_RIGHT", 2000);
            return;
        }

        if (value.CustomerID === 0) {
            pushNotification("Chưa xác nhận được thông tin đại lý. Vui lòng tải lại trang", "error", "TOP_RIGHT", 2000);
            return;
        }
        if (value.lstChiTiet.length === 0) {
            pushNotification("Chưa có sản phẩm nào", "error", "TOP_RIGHT", 2000);

            return;
        } else {
            value.lstChiTiet.map((cate, i) => {
                if (cate.SaleTime != null) {
                    cate.SaleTime = moment(cate.SaleTime).format("YYYY-MM-DD HH:mm:ss");
                } else {
                    cate.SaleTime = moment(value.CreatedTime).format(
                        "YYYY-MM-DD HH:mm:ss"
                    );
                }
            });
        }

        var dateTaoDon = formatDayMonth(value.CreatedTime);
        var dateGiaoHang = formatDayMonth(value.NgayDuKienGiao);
        if (dateGiaoHang != "") {
            if (process(dateGiaoHang) < process(dateTaoDon)) {
                pushNotification(
                    "Thời gian nhận hàng dự kiến > thời gian tạo đơn",
                    "error",
                    "TOP_RIGHT",
                    2000
                );
                return;
            }
        }

        value.CreatedTime = moment(value.CreatedTime).format("YYYY-MM-DD HH:mm:ss");
        if (value.HanThanhToan !== null) {
            value.HanThanhToan = moment(value.HanThanhToan).format(
                "YYYY-MM-DD HH:mm:ss"
            );
        }
        if (value.NgayDuKienGiao !== null && value.NgayDuKienGiao != undefined) {
            value.NgayDuKienGiao = moment(value.NgayDuKienGiao).format(
                "YYYY-MM-DD HH:mm:ss"
            );
        }

        setLoadding(true);
        setDoubleClick(true);
        if (value.IsLayHoaDon === true) {
            value.TotalAmount = value.TotalAmountNew;
        } else {
            value.TotalAmountNew = 0;
            value.TotalAmountThueGTGT = 0;
        }
        value.ChietKhau_NhomSP = totalChietKhauNhom;
        value.listChietKhauNhom = listChietKhauNhom;
        const param2 = value;
        var params = param2;
        if (sCode > 0) {
            DatHangApi.addOrUpdateDatHang(params).then((response) => {
                if (response.status == 200) {
                    pushNotification(
                        "Cập nhật đơn đặt hàng thành công",
                        "success",
                        "TOP_RIGHT",
                        2000
                    );
                    setDataBanHang({
                        ...dataBanHang,
                        OrderDatHangID: 0,
                        OrderCode: "",
                        CreatedTime: new Date(),
                        UpdatedTime: new Date(),
                        CreatedUser: getUserLogin().UserName,
                        UpdatedUser: "",
                        Note: "",
                        CustomerID: 0,
                        CustomerName: "",
                        CustomerAddress: "",
                        Phone: "",
                        AccountBank: "",
                        TaxCode: "",
                        TotalAmount: 0,
                        TotalPaid: 0,
                        TotalPaidOlder: 0,
                        StoreExportStatus: 1 /*1 trừ kho - 0 không trừ kho*/,
                        IsAddTax: true,
                        DatePaid: new Date(),
                        OtherFee: 0,
                        CustomerDebt: 0,
                        ChietKhau: 0,
                        GiaoHang: true,
                        Approval: 0,
                        BankId: 0 /*ngân hàng*/,
                        TypeMoney: 0,
                        NgayTao: new Date(),
                        NgayCapNhat: new Date(),
                        BranchID: 0,
                        ChietKhau_CongThuc: "",
                        // IsAutoTruKho: false,
                        TrangThaiGiaoNhan: 0,
                        NgayDuKienGiao: new Date(),
                        IsDuHang: true,
                        TotalAmountThueGTGT: 0,
                        IsLayHoaDon: false,
                        ThueGTGT: 0,
                        HanThanhToan: null,
                        POCode: "",
                        lstChiTiet: [],
                        NVKD: "",
                        NVKDID: 0,
                        BranchName: "",
                        IsDoiTac: true,
                        isShowThueGTGT: false,
                        isRoleGiaoNhan: null,
                        TotalAmountNew: 0,
                        SoNgayNo: 0,
                        sUserName: getUserLogin().UserName,
                        isShowGiaVon: false,
                        BankName: "Tiền mặt",
                        ConfigSuaNgay: null,
                        ConfigPhienBan: null,
                        ConfigThueGTGT: null,
                        ConfigCanhBaoDHQuaHan: null,
                        ConfigMaPO: null,
                        ConfigNhanVienKinhDoanh: null,
                        ConfigChuaGiCong: null,
                        ConfigTruKhoGiaCong: null,
                        configThuocTinhKhac: "0",
                        ConfigBanBuonBanLe: null,
                        ConfigTiTrong: null,
                        configChietKhau: null,
                        configDateChiTietDH: null,
                        ConfigBanAm: null,
                        ConfigTruKhoVaoNgayTao: null,
                        ConfigSuaSanPhamBanHang: null,
                        ConfigShowTTKTheoNhom: null,
                        ConfigMauHoaDon: "",
                        ConfigThanhToanDHCu: null,
                        ConfigLamTronTien: null,
                        ConfigCongThucCK: null,
                        ChietKhau_NhomSP: 0,
                    });
                    setDHQuaHanThanhToan(0);
                    setListNhomSP([]);
                    setPageActive(1);
                    setListChietKhauNhom([]);
                    setDisEditAll(false);
                    setDisEditKH(false);
                    setDisEditDonGia(false);
                    setListChietKhauNhomKH({});
                    setTimeout(function () {
                        setDoubleClick(false);
                    }, 2000);

                    setTimeout(function () {
                        window.location.href = "/DanhSachDatHang"
                    }, 2000);
                } else if (response.status == 500) {
                    setDoubleClick(false);
                    if (response.data === "NhomChoDuyet") {
                        toggleModal();
                    } else if (response.data === "CongNoChoDuyet") {
                        toggleModal();
                    } else if (response.data === "CongNoChoDuyetTheoSP") {
                        toggleModalTheoNhomSP();
                    } else {
                        pushNotification(response.data, "error", "TOP_RIGHT", 4000);
                    }
                }
                setLoadding(false);
            });
        } else {
            DatHangApi.addOrUpdateDatHang(params).then((response) => {
                if (response.status == 200) {

                    pushNotification(
                        "Gửi thông tin yêu cầu đặt hàng thành công",
                        "success",
                        "TOP_RIGHT",
                        2000
                    );
                    setDataBanHang({
                        ...dataBanHang,
                        OrderDatHangID: 0,
                        OrderCode: "",
                        CreatedTime: new Date(),
                        UpdatedTime: new Date(),
                        CreatedUser: getUserLogin().UserName,
                        UpdatedUser: "",
                        Note: "",
                        CustomerID: 0,
                        CustomerName: "",
                        CustomerAddress: "",
                        Phone: "",
                        AccountBank: "",
                        TaxCode: "",
                        TotalAmount: 0,
                        TotalPaid: 0,
                        TotalPaidOlder: 0,
                        StoreExportStatus: 1 /*1 trừ kho - 0 không trừ kho*/,
                        IsAddTax: true,
                        DatePaid: new Date(),
                        OtherFee: 0,
                        CustomerDebt: 0,
                        ChietKhau: 0,
                        GiaoHang: true,
                        Approval: 0,
                        BankId: 0 /*ngân hàng*/,
                        TypeMoney: 0,
                        NgayTao: new Date(),
                        NgayCapNhat: new Date(),
                        BranchID: 0,
                        ChietKhau_CongThuc: "",
                        // IsAutoTruKho: false,
                        TrangThaiGiaoNhan: 0,
                        NgayDuKienGiao: new Date(),
                        IsDuHang: true,
                        TotalAmountThueGTGT: 0,
                        IsLayHoaDon: false,
                        ThueGTGT: 0,
                        HanThanhToan: null,
                        POCode: "",
                        lstChiTiet: [],
                        NVKD: "",
                        NVKDID: 0,
                        BranchName: "",
                        IsDoiTac: true,
                        isShowThueGTGT: false,
                        isRoleGiaoNhan: null,
                        TotalAmountNew: 0,
                        SoNgayNo: 0,
                        sUserName: getUserLogin().UserName,
                        isShowGiaVon: false,
                        BankName: "Tiền mặt",
                        ConfigSuaNgay: null,
                        ConfigPhienBan: null,
                        ConfigThueGTGT: null,
                        ConfigCanhBaoDHQuaHan: null,
                        ConfigMaPO: null,
                        ConfigNhanVienKinhDoanh: null,
                        ConfigChuaGiCong: null,
                        ConfigTruKhoGiaCong: null,
                        configThuocTinhKhac: "0",
                        ConfigBanBuonBanLe: null,
                        ConfigTiTrong: null,
                        configChietKhau: null,
                        configDateChiTietDH: null,
                        ConfigBanAm: null,
                        ConfigTruKhoVaoNgayTao: null,
                        ConfigSuaSanPhamBanHang: null,
                        ConfigShowTTKTheoNhom: null,
                        ConfigMauHoaDon: "",
                        ConfigThanhToanDHCu: null,
                        ConfigLamTronTien: null,
                        ConfigCongThucCK: null,
                        ChietKhau_NhomSP: 0,
                    });
                    setDHQuaHanThanhToan(0);
                    setListNhomSP([]);
                    setPageActive(1);
                    setListChietKhauNhom([]);
                    setDisEditAll(false);
                    setDisEditKH(false);
                    setDisEditDonGia(false);
                    setListChietKhauNhomKH({});
                    setTimeout(function () {
                        setDoubleClick(false);
                    }, 2000);

                    setTimeout(function () {
                        window.location.href = "/DanhSachDatHang"
                    }, 2000);

                } else if (response.status == 500) {
                    setDoubleClick(false);
                    if (response.data === "NhomChoDuyet") {
                        toggleModal();
                    } else if (response.data === "CongNoChoDuyet") {
                        toggleModal();
                    } else if (response.data === "CongNoChoDuyetTheoSP") {
                        toggleModalTheoNhomSP();
                    } else {
                        pushNotification(response.data, "error", "TOP_RIGHT", 4000);
                    }
                }
                setLoadding(false);
            });
        }
    };

    const [isModalVisible, setModalVisible] = useState(false);
    const toggleModal = () => {
        setModalVisible(!isModalVisible);
    };

    const [isModalVisibleNhomSP, setModalVisibleTheoNhomSP] = useState(false);
    const toggleModalTheoNhomSP = () => {
        setModalVisibleTheoNhomSP(!isModalVisibleNhomSP);
    };

    const onChangeText = (field, e) => updateStateThongTin(field, e);
    const updateStateThongTin = (field, e) => {
        const thongtin = { ...dataBanHang };
        //const value = e.target.validity.valid ? e.target.value : thongtin[field];
        thongtin[field] = e.target.value;
        setDataBanHang(thongtin);
    };


    return (
        <>
            <div class="content_New_Main right-form-new">
                <div class="form-new ">
                    <div className="row">
                        <div class="col-sm-12">
                            <div class="form-group  align-centerNew ">
                                <div class="form-new-input-left textArea-w">
                                    <label class="label-control text-left-main" for="eventRegInput2">
                                        Ghi chú đặt hàng
                                    </label>
                                    <textarea
                                        class="form-control text-left"
                                        rows="1"
                                        value={dataBanHang.Note}
                                        onChange={(e) => onChangeText("Note", e)}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class={
                    isShowMenu === true
                        ? "bottom-white-new bottom-white-layoutNew"
                        : "bottom-white-new"
                }
            >
                <div style={{ width: "100%" }}>
                    <div className="col-md-8">
                        <div className="row">
                            <div class="col-md-6">
                                <h2 class="title-text-money">
                                    Tổng tiền:{" "}
                                    <span class="color-money">
                                        <NumberFormat
                                            class="text-right"
                                            displayType={"text"}
                                            value={LamTronNghin(
                                                CustomerParseFloat(
                                                    numeral(dataBanHang.TotalAmount).format("0.[0000]")
                                                ),
                                                dataBanHang.ConfigLamTronTien
                                            )}
                                            thousandSeparator={true}
                                        />{" "}
                                        đ
                                    </span>
                                </h2>
                            </div>

                            {dataBanHang.isShowThueGTGT && (
                                <>
                                    <div class="col-md-6">
                                        <h2 class="title-text-money">
                                            Thuế GTGT:{" "}
                                            <span class="color-money">
                                                <NumberFormat
                                                    class="text-right"
                                                    displayType={"text"}
                                                    // value={dataBanHang.TotalAmountThueGTGT}
                                                    value={LamTronNghin(
                                                        dataBanHang.TotalAmountThueGTGT,
                                                        false
                                                    )}
                                                    thousandSeparator={true}
                                                />{" "}
                                                đ
                                            </span>
                                        </h2>
                                    </div>
                                    <div class="col-md-6">
                                        <h2 class="title-text-money">
                                            Tổng tiền thanh toán:{" "}
                                            <span class="color-money">
                                                <NumberFormat
                                                    class="text-right"
                                                    displayType={"text"}
                                                    // value={dataBanHang.TotalAmountNew}
                                                    value={LamTronNghin(
                                                        dataBanHang.TotalAmountNew,
                                                        false
                                                    )}
                                                    thousandSeparator={true}
                                                />{" "}
                                                đ
                                            </span>
                                        </h2>
                                    </div>
                                </>
                            )}

                            <div class="col-md-6">
                                <h2 class="title-text-money">
                                    Nợ:{" "}
                                    <span class="color-money">
                                        <NumberFormat
                                            class="text-right"
                                            displayType={"text"}
                                            value={LamTronNghin(
                                                dataBanHang.CustomerDebt,
                                                dataBanHang.ConfigLamTronTien
                                            )}
                                            thousandSeparator={true}
                                        />{" "}
                                        đ
                                    </span>
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="footer-bottom-new footer-button-new">
                            <button
                                type="button"
                                class="button-Add-NoIcon bg-blue-main"
                                style={{ marginLeft: "10px" }}
                                onClick={saveBanHang}
                                disabled={doubleClick}
                                ref={saveButtonRef}
                            >
                                Gửi yêu cầu đặt hàng
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
